<template>
	<div>
		<el-carousel :interval="5000" arrow="always" height="45px" indicator-position="none">
			<el-carousel-item v-for="(item, index) in list" :key="index">
				<div class="container-cls">
					<div @click.stop="handleView(_item)" class="cell" v-for="(_item, _index) in item" :key="_index">
						<i>New</i>
						<span>{{_item.q}}</span>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters([
			'userInfo',
		])
	},
	data() {
		return {
			list: []
		}
	},
	async created() {
		await this.getList();
	},
	methods: {
		getList() {
			this.$api.apiPostKnowledgeSelectNewQaList({
				projectId: this.userInfo.brandIdentify,
				status: '1'
			}).then(response => {
				if(response.errcode != 0) return;
				const baseArray = response.data;
				const len = baseArray.length;
				const n = 2;
				const lineNum = len % n === 0 ? len / n : Math.floor( (len / n) + 1 );
				for (let i = 0; i < lineNum; i++) {
					let temp = baseArray.slice(i*n, i*n+n);
					this.list.push(temp);
				}
			});
		},
		handleView(item) {
			this.$emit('EditBigScreenInfo', item.id);
		}
	}
}
</script>

<style lang="scss" scoped>
.main-carousel-cls {
	width: 100%;
	height: 45px;
	background: #F3F3F3;
	margin-bottom: 20px;

	::v-deep .el-carousel__arrow  {
		width: 16px;
		height: 16px;
		background: #DEDFDF;

		& i {
			color: #A6AAB8;
			font-weight: bold;
		}
	}

	& .container-cls {
		width: 500px;
		height: 100%;
		margin: 0 auto;

		& > .cell {
			display: inline-block;
			vertical-align: top;
			width: 50%;
			height: 100%;
			padding: 13.5px 0;
			box-sizing: border-box;
			text-align: center;

			& > i {
				vertical-align: top;
				width: 38px;
				height: 18px;
				background: #FF504D;
				border-radius: 18px;
				display: inline-block;
				font-size: 11px;
				color: #fff;
				text-align: center;
				line-height: 18px;
				margin-right: 3px;
				cursor: pointer;
			}

			& > span {
				vertical-align: top;
				font-size: 12px;
				font-weight: 400;
				color: #3C4353;
				cursor: pointer;
			}
		}
	}
}
</style>